.svg {
	display: block;
	width: 100%;
	height: 120px;
	transform: scaleX(-1);
}

.blue1 {
	color: #008fb0;
}
.blue2 {
	color: #b2d6ee;
}
.gray1 {
	color: #d9e1e2;
}
.gray2 {
	color: #768692;
}

.variantBlue {
	.accent {
		color: #3392d3;
	}
}
.variantOrange {
	.accent {
		color: #efb53f;
	}
}
.variantGreen {
	.accent {
		color: #8bc058;
	}
}

.variantRed {
	.accent {
		color: #e57a8e;
	}
}
